namespace _Ext {
    export interface AuditLogRequest extends Serenity.ListRequest {
        EntityId?: number;
        TableName?: string;
    }
}
